import type { Member } from "../types/member";

export const DEFAULT_MEMBER: Member = {
  full_name: {
    title: "",
    first_name: "Kostyantyn2345",
    middle_name: "",
    last_name: "Kulyk1",
    sys_root: "Kostyantyn2345 Kulyk1",
  },
  company_name: "Ekreative33",
  department: "Logistics",
  about_me: "something about me",
  job_title: "Developer3",
  email: ["kkulyk@ukr.net"],
  status: {
    value: "1",
    updated_on: "2021-05-28T11:41:16.524000Z",
  },
  type: "4",
  role: "1",
  locale: "en-US",
  timezone: "GMT",
  language: "en",
  office_location: {
    location_address: "Hotkevycha32",
    location_address2: "qqqqq12",
    location_city: "Lviv",
    location_state: "Львівська область2",
    location_zip: "790703",
    location_country: "Ukraine",
    location_longitude: "0",
    location_latitude: "0",
    sys_root: "",
  },
  work_anniversary: {
    date: "2022-02-25T00:00:00Z",
    include_time: false,
  },
  certifications: ["some certifications"],
  skills: ["some skillks"],
  hobbies: ["some hobbies"],
  linkedin: [""],
  twitter: [""],
  facebook: [""],
  instagram: [""],
  theme: "smartsuite_primary",
  dob: {
    date: "1970-02-20T00:00:00Z",
    include_time: false,
  },
  profile_image: [],
  cover_image: [],
  cover_template: null,
  biography: [],
  phone: [],
  teams: ["60b0d6dde088d203177ff978"],
  ip_address: [],
  last_login: {
    date: "2023-02-03T09:35:18.269000Z",
    include_time: true,
  },
  availability_status: {
    emoji: "",
    status: "",
    selected_interval: "",
    clear_after: {
      date: null,
      include_time: false,
    },
  },
  first_created: {
    on: "2021-05-28T11:41:16.522000Z",
    by: "60b0d6dce088d203177ff973",
  },
  last_updated: {
    on: "2022-09-22T06:08:53.012000Z",
    by: "60b0d6dce088d203177ff973",
  },
  deleted_date: {
    date: null,
    include_time: false,
  },
  id: "63e5364bfbf9e43af8f3ad03",
  application_slug: "members",
  application_id: "somedefaultmemberappid",
  title: "",
  comments_count: 0,
  image: "",
  user_id: 0,
  status_id: 0,
  type_id: 0,
  role_id: 0,
  followed_by: [],
};

export const EMPTY_MEMBER: Member = {
  full_name: {
    title: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    sys_root: "",
  },
  company_name: "",
  department: "",
  about_me: "",
  job_title: "",
  email: ["kkulyk@ukr.net"],
  status: {
    value: "1",
    updated_on: "2021-05-28T11:41:16.524000Z",
  },
  type: "4",
  role: "1",
  locale: "",
  timezone: "",
  language: "en",
  office_location: {
    location_address: "",
    location_address2: "",
    location_city: "",
    location_state: "",
    location_zip: "",
    location_country: "",
    location_longitude: "0",
    location_latitude: "0",
    sys_root: "",
  },
  work_anniversary: {
    date: "2022-02-25T00:00:00Z",
    include_time: false,
  },
  certifications: ["some certifications"],
  skills: ["some skillks"],
  hobbies: ["some hobbies"],
  linkedin: [""],
  twitter: [""],
  facebook: [""],
  instagram: [""],
  theme: "smartsuite_primary",
  dob: {
    date: "1970-02-20T00:00:00Z",
    include_time: false,
  },
  profile_image: [],
  cover_image: [],
  cover_template: null,
  biography: [],
  phone: [],
  teams: [],
  ip_address: [],
  last_login: {
    date: "2023-02-03T09:35:18.269000Z",
    include_time: true,
  },
  availability_status: {
    emoji: "",
    status: "",
    selected_interval: "",
    clear_after: {
      date: null,
      include_time: false,
    },
  },
  first_created: {
    on: "2021-05-28T11:41:16.522000Z",
    by: "60b0d6dce088d203177ff973",
  },
  last_updated: {
    on: "2022-09-22T06:08:53.012000Z",
    by: "60b0d6dce088d203177ff973",
  },
  deleted_date: {
    date: null,
    include_time: false,
  },
  id: "someemptymemberid",
  application_slug: "members",
  application_id: "someemptymemberappid",
  title: "",
  comments_count: 0,
  image: "",
  user_id: 0,
  status_id: 0,
  type_id: 0,
  role_id: 0,
  followed_by: [],
};
